import { CalculationStatus, CalculationType } from '../enums';
import { CalculationInput } from './calculation-input';
import { CalculationResult } from './calculation-result';
import { CalculationComment } from './calculation-comment';
import { LocationInfo } from '../common';

export class RiskCalculationDetailView {
    public id: string;

    public location: LocationInfo;

    public createdAt: Date;
    public calculationStatus: CalculationStatus;
    public calculationType: CalculationType;

    public calculationInput: CalculationInput;
    public calculationResult: CalculationResult;

    public calculationFailed: boolean;
    public calculationFailedErrorMessage: string;

    public comments: CalculationComment[];

    public constructor(init: Partial<RiskCalculationDetailView>) {
        Object.assign(this, init);
    }
}
